const HTML5_FMT = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm',
}

export { HTML5_FMT }
